// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2Y-Cc","spin":"Loader_spin__3bKUW"};